import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import './index.css';
import Desktop from 'components/Desktop';
import store from 'redux/store';

// This project requests Node 16.20.2

ReactDOM.render(
  <Provider store={store}>
    <Desktop />
  </Provider>,
  document.getElementById('app-start')
);
